import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAds = (ads) => ({
  type: actionTypes.SET_ADS,
  payload: ads
})
